// @flow
import common from 'modules/Common/lang/cn'
import landing from 'modules/Authenticate/lang/cn'
import admin from 'modules/Admin/lang/cn'

export default {
  common,
  landing,
  admin
}
